import moment from 'moment';
import {
  BUYER_ORDER_UNPAID,
  BUYER_ORDER_PAID,
  BUYER_ORDER_COLLECTED,
  BUYER_ORDER_CANCELED,
  BUYER_REFUNDED,
  HOST_ORDER_CANCELED,
  HOST_ORDER_REFUNDED,
  HOST_ORDER_UNPAID,
  HOST_ORDER_VERIFIED,
  HOST_ORDER_COLLECTED,
  HOST_ORDER_SUBMITTED_UNPAID,
  HOST_ORDER_SUBMITTED_VERIFIED,
  HOST_ORDER_SUBMITTED_COLLECTED,
} from '_utils/constant';
import {
  isDisableEvent,
  convertToCurrentGMT,
  convertTimeStringWithDurationTwoPart,
} from '_utils/function';
import { PURCHASE_STATUS } from '../constant/constant';

export const resolvePurchaseCardState = (order) => {
  const { buyerStatus, status, ePickupTime, ePickupDuration } = order || {};
  const currentPickupTime = convertToCurrentGMT(ePickupTime);
  const isDisable = isDisableEvent(status, buyerStatus, currentPickupTime, ePickupDuration);

  const [pickupDate, pickupHours] = ePickupTime && ePickupDuration
    ? convertTimeStringWithDurationTwoPart(ePickupTime, ePickupDuration)
    : ['', ''];
  const meta = pickupDate ? `${pickupDate}<br/>${pickupHours}` : '';

  const formattedDate = pickupDate && moment(pickupDate, 'DD-MM-YYYY').isValid()
    ? moment(pickupDate, 'DD-MM-YYYY').format('D MMM')
    : pickupDate;
  const timeInfo = formattedDate && pickupHours ? `${formattedDate} · ${pickupHours}` : '';

  // 1. Đơn bị Refund
  if (buyerStatus === BUYER_REFUNDED) {
    return {
      status: PURCHASE_STATUS.REFUND,
      statusText: 'Refunded',
      meta,
      isDisable,
    };
  }

  // 2. Đơn bị Cancel
  const isCanceled =
    buyerStatus === BUYER_ORDER_CANCELED ||
    status === HOST_ORDER_CANCELED;

  if (isCanceled) {
    return {
      status: PURCHASE_STATUS.CANCEL,
      statusText: 'Cancel',
      meta,
      isDisable,
    };
  }

  // 2. Đơn đã Collected (Buyer đã nhận hoặc Host đã phát hàng)
  const isCollected =
    buyerStatus === BUYER_ORDER_COLLECTED ||
    status === HOST_ORDER_COLLECTED ||
    status === HOST_ORDER_SUBMITTED_COLLECTED;

  if (isCollected) {
    return {
      status: PURCHASE_STATUS.COLLECTED,
      statusText: 'Collected',
      meta,
      isDisable,
    };
  }

  // 3. Chờ thanh toán (Unpaid)
  if (
    buyerStatus === BUYER_ORDER_UNPAID &&
    (status === HOST_ORDER_UNPAID || status === HOST_ORDER_SUBMITTED_UNPAID)
  ) {
    return {
      status: PURCHASE_STATUS.UNPAID,
      statusText: '',
      meta,
      isDisable,
    };
  }

  // 4. Chờ xác nhận
  // 4.1. Đã thanh toán, host đã refund và chờ buyer xác nhận
  if (
    buyerStatus === BUYER_ORDER_PAID &&
    status === HOST_ORDER_REFUNDED
  ) {
    return {
      status: PURCHASE_STATUS.PENDING,
      statusText: 'Pending refund confirmation',
      meta,
      isDisable,
    };
  }

  // 4.2. Đã thanh toán, chờ host xác nhận (Pending confirmation)
  if (
    buyerStatus === BUYER_ORDER_PAID &&
    (status === HOST_ORDER_UNPAID || status === HOST_ORDER_SUBMITTED_UNPAID)
  ) {
    return {
      status: PURCHASE_STATUS.PENDING,
      statusText: 'Pending confirmation',
      meta,
      isDisable,
    };
  }

  // 5. Host đã verify (Ready hoặc Fulfill)
  if (
    buyerStatus === BUYER_ORDER_PAID &&
    (status === HOST_ORDER_VERIFIED || status === HOST_ORDER_SUBMITTED_VERIFIED)
  ) {
    const pickupMoment = moment(currentPickupTime?.split(' ')[0], 'DD-MM-YYYY').startOf('day');
    const todayMoment = moment().startOf('day');
    const diffDays = pickupMoment.diff(todayMoment, 'days');

    if (diffDays <= 0) {
      return {
        status: PURCHASE_STATUS.READY,
        statusText: timeInfo ? `Collection today · ${timeInfo}` : 'Collection today',
        meta,
        isDisable,
        isVerified: true,
      };
    }

    return {
      status: PURCHASE_STATUS.FULFILL,
      statusText: timeInfo ? `To be fulfilled on ${timeInfo}` : 'To be fulfilled',
      meta,
      isDisable,
      isVerified: true,
    };
  }

  // Fallback mặc định
  return {
    status: PURCHASE_STATUS.PENDING,
    statusText: 'Pending confirmation',
    meta,
    isDisable,
  };
};

export default resolvePurchaseCardState;
